import { createFileRoute } from "@tanstack/react-router";
import { RegulatoryFilings } from "@/components/RegulatoryFilings";

function RouteComponent() {
  return <RegulatoryFilings />;
}

export const Route = createFileRoute("/_authenticated/regulatory-filings/")({
  component: RouteComponent,
  staticData: { page: "compliance" },
});
